import { createSelector } from '@reduxjs/toolkit';
import { firebaseSelector } from './firebase';

export const profileSelector = createSelector(firebaseSelector, (firebase) => firebase?.profile);

export const uidSelector = createSelector(profileSelector, (profile) => profile?.id);

export const authSelector = createSelector(firebaseSelector, (firebase) => firebase?.auth);
